// extracted by mini-css-extract-plugin
export default {"callTime":"CallTime_callTime__NjzGC","productionName":"CallTime_productionName__X4X7P","welcomeMessage":"CallTime_welcomeMessage__yY9Nk","buttonPanel":"CallTime_buttonPanel__M3JKQ"};